// extracted by mini-css-extract-plugin
export var alternateContainer = "offer-module--alternateContainer--zKpAV";
export var alternateIcon = "offer-module--alternateIcon--Uoc9+";
export var container = "offer-module--container--4vMCx";
export var subtitle = "offer-module--subtitle--WOEmi";